/*
class to centralize and simplify formatting for ICE Climate Risk Scores (number formatting, coloring, etc)
*/
import chroma from 'chroma-js'

function compact(list) {
    return list.filter((obj) => obj);
}

export function capitalize (str) {
    return str[0].toUpperCase() + str.slice(1)
}

export class risQScores {
    //static orangePoint = 3.5
   static orangePoint = 2.69



    //bezier makes points closer to perceptually equidistant
    // gamma moves it so that more of the scale is in the yellow range
    //(this helps make high end of range perceptually distinguishable, especially when using night shift)
    static scaleArray = chroma.bezier(['#fafa6e','#fc035e']).scale().gamma(1.3).colors(8);
    static legendRange = [5.0, 4.8, 4.5, 4.0, 3.5, 3.0, 2.0, 1.0]

    static invertedLegendRange = this.legendRange.map((x,i)=> this.legendRange[7-i])
    static scale = chroma.scale(this.scaleArray).domain(this.invertedLegendRange)
    static legendRange = [5.0, 4.8, 4.5, 4.0, 3.5, 3.0, 2.0, 1.0]
    static subscoreTypes = ['hurricane','flood','wildfire']

    static getTextColor(num) {
    //   return  chroma.scale(['#fafa6e','#fa0202']).mode('lch').colors(8)
        //return this.scale(num).hex()
        return num < this.orangePoint ? '#696969' : this.scale(num).hex()
    }
    static getColor(num) {
        // return chroma.scale(['#fafa6e','#fa0202'])
    // .mode('lch').colors(8)
        return this.scale(num)
        return num < this.orangePoint ? this.lowscale(num) : this.highscale(num)
    }
    constructor(total,hurricane,flood,wildfire, weight=null) {
        this.total_unrounded = total
        this.risq_unrounded = total
        this.hurricane_unrounded = hurricane
        this.flood_unrounded = flood
        this.wildfire_unrounded = wildfire

        this.total = parseFloat(total).toFixed(1)
        this.risq = this.total
        this.hurricane = parseFloat(hurricane).toFixed(1)
        this.flood = parseFloat(flood).toFixed(1)
        this.wildfire = parseFloat(wildfire).toFixed(1)
        this.subscores = compact([this.hurricane,this.flood,this.wildfire]) //the "compact" is probably superflous but there in case we're fed nulls
        this.weight = weight

    }

    isMax(scoreName) {
        return this[scoreName] >= Math.max(...this.subscores)
    }

    toHtml(scoreName) {
        const tag = this.isMax(scoreName) ? 'b' : 'span'
        return  `<${tag} style="color:${risQScores.getTextColor(this[scoreName])}">${this[scoreName]}</${tag}>`
    }

    color(scoreName) {
        return risQScores.getColor(this[scoreName]);
    }
}

export class PortfolioRisQScores {
    constructor(scores) {
        this.scores = scores
        this.total = this.computePortfolioScore('total_unrounded')
        this.hurricane = this.computePortfolioScore('hurricane_unrounded')
        this.flood = this.computePortfolioScore('flood_unrounded')
        this.wildfire = this.computePortfolioScore('wildfire_unrounded')
        this.subscores = compact([this.hurricane,this.flood,this.wildfire]) //the "compact" is probably superflous but there in case we're fed nulls
        this.useWeights = (this.scores.filter(item => item.weight)).length > 0
    }

    weightedAverage(score_name) {
        let compactScores = this.scores.filter(item => item['total'])
        let useWeights = this.useWeights
        let weightedScores = compactScores.map((item) => {
            if (useWeights) {
                let score = item[score_name] || 0
                let weight = item['weight'] || 0
                let powered = weight * Math.pow(2,score)
                // console.log(score, weight, powered)
                return powered
            } else {
                // console.log("unweighted")
                return Math.pow(2,item[score_name] || 0)
            }
        })
        // console.log(weightedScores)
        let sum = weightedScores.reduce((acc, curr) => acc + curr, 0)
        if (weightedScores.length === 0) {
            return null
        } else {
            let denominator = useWeights ? compactScores.reduce((acc, curr) => acc + (curr['weight'] || 0), 0) : compactScores.length
            // console.log(sum, '/', denominator)
            // console.log(`Weighted average for ${weightedScores.length} ${score_name} >>>  ${sum}/${denominator} = ${sum/denominator}`)
            return sum / denominator
        }
    }

    computePortfolioScore(score_name) {
        let weighted_average = this.weightedAverage(score_name)
        return weighted_average ? parseFloat(Math.log2(weighted_average)).toFixed(1) : '-'
    }

    /* TODO: learn how to do real inheritance instead of copying and pasting like below */
    static orangePoint = 2.69
    static lowscale = chroma.scale(['#fff3ae', '#fdbf0b']).domain([1.0,this.orangePoint])
    static highscale = chroma.scale(['#fdbf0b', '#F20300']).domain([this.orangePoint,5.0])
    static legendRange = [5.0, 4.8, 4.5, 4.0, 3.5, 3.0, 2.0, 1.0]

    static getTextColor(num) {
        return num < this.orangePoint ? '#696969' : this.highscale(num).hex()
    }
    static getColor(num) {
        return num < this.orangePoint ? this.lowscale(num) : this.highscale(num)
    }
   toHtml(scoreName) {
        const tag = this.isMax(scoreName) ? 'b' : 'span'
        return  `<${tag} style="color:${risQScores.getTextColor(this[scoreName])}">${this[scoreName]}</${tag}>`
    }

    isMax(scoreName) {
        return this[scoreName] >= Math.max(...this.subscores)
    }

    color(scoreName) {
        return risQScores.getColor(this[scoreName]);
    }

    pctOver(threshold, score_name) {
        let scoresOver = this.scores.filter(item => item[score_name] && item[score_name] >= threshold)
        let retVal = 0
        if (this.scores.length == 0) {
            retVal = 0
        } else if (this.useWeights) {
            let weightedAbove = scoresOver.reduce((acc, curr) => acc + curr['weight'], 0)
            let denominator = this.scores.reduce((acc, curr) => acc + curr['weight'], 0)
            retVal = (weightedAbove / denominator)*100
        } else {
            retVal = (scoresOver.length / this.scores.length)*100
        }
        if (retVal == 0) {
            return '-'
        } else {
            return parseFloat(retVal).toFixed(1) + '%'
        }
    }

}
